import React from 'react';
import MuiGrid from '@material-ui/core/Grid';
import sanitizeRestProps from '../helper/sanitizeRestProps';

const Grid = ({ children, className, container, spacing, item, xs, sm, md, lg, ...props }) => {
	return (
		<MuiGrid container={container} spacing={spacing} item={item} xs={xs} sm={sm} md={md} lg={lg} {...sanitizeRestProps(props)}>
			{React.Children.map(children, child => { return React.cloneElement(child, { ...props }) })}
		</MuiGrid>
	)
}

export default Grid;
